import {
  countryAustraliaId,
  countryUSAid,
  countryMexicoId,
  countryCanadaId,
} from 'constants/index';

const countriesWithStatesDropdown: number[] = [
  countryUSAid,
  countryAustraliaId,
  countryMexicoId,
  countryCanadaId,
];

const checkIsCountriesWithStatesDropdown = (
  countryId?: number | null | string,
) => {
  if (!countryId) return;
  return countriesWithStatesDropdown.includes(+countryId);
};

export { countriesWithStatesDropdown, checkIsCountriesWithStatesDropdown };
